import { render, staticRenderFns } from "./Editions.vue?vue&type=template&id=56786f04&scoped=true"
import script from "./Editions.vue?vue&type=script&lang=js"
export * from "./Editions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56786f04",
  null
  
)

export default component.exports